export interface TransactionReportClientFilters {
  date_from: string;
  date_to: string;
  date_type: 'transaction' | 'status_change';
  status: string[];
  transaction_type: 'sales' | 'rentals' | 'all';
  market_center: string[];
  team: string;
  associate: string;
  attorney: string[];
  attorney_role: '' | 'transfer' | 'bond';
  originator: string[];
  financing_type: string;
  search: string;
  page: number;
  page_size: number;
  sort_by: string;
  sort_direction: 'asc' | 'desc';
}

export function buildTransactionReportParams(filters: TransactionReportClientFilters, includePaging = true): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (!includePaging && (key === 'page' || key === 'page_size')) continue;
    if (value == null || value === '') continue;
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry !== '') params.append(key, String(entry));
      });
      continue;
    }
    params.set(key, String(value));
  }
  return params;
}

export function transactionReportHeaders(token: string | null, activeContextId: string | null | undefined): HeadersInit {
  return {
    Authorization: `Bearer ${token ?? ''}`,
    'X-Active-Context': activeContextId ?? '',
  };
}

export function isCurrentTransactionReportRequest(active: boolean, signal: AbortSignal): boolean {
  return active && !signal.aborted;
}

export function defaultTransactionReportFilters(today: string): TransactionReportClientFilters {
  return {
    date_from: `${today.slice(0, 7)}-01`, date_to: today, date_type: 'transaction', status: [], transaction_type: 'sales',
    market_center: [], team: '', associate: '', attorney: [], attorney_role: '', originator: [], financing_type: '',
    search: '', page: 1, page_size: 25, sort_by: 'transactionDate', sort_direction: 'desc',
  };
}